export default __webpack_public_path__ + "static/media/SimhachalamDiety.2b1af066.png";